module.exports = __webpack_public_path__ + "static/media/refundCheck.1adac408.svg";